import kc from './keycloak';

// Token update events
const tokenUpdateEmitter = {
  // Event listeners
  listeners: [],

  // Add listener
  addListener: function(callback) {
    this.listeners.push(callback);
    return () => {
      this.removeListener(callback);
    };
  },

  // Remove listener
  removeListener: function(callback) {
    this.listeners = this.listeners.filter(listener => listener !== callback);
  },

  // Emit event
  emit: function(eventData) {
    this.listeners.forEach(callback => {
      try {
        callback(eventData);
      } catch (error) {
        console.error('Error in token update listener:', error);
      }
    });
  }
};

// Get the current token
export function getToken() {
  return kc.token;
}

// Get the current refresh token
export function getRefreshToken() {
  return kc.refreshToken;
}

// Get the ID token
export function getIdToken() {
  return kc.idToken;
}

// Update tokens after refresh
export function updateTokens(accessToken, idToken, refreshToken, timeSkew = 0) {
  kc.token = accessToken;
  kc.idToken = idToken;
  kc.refreshToken = refreshToken;
  kc.timeSkew = timeSkew || 0;
  
  // Store time_skew in localStorage
  window.localStorage.setItem('time_skew', kc.timeSkew);
  
  // Emit token update event
  tokenUpdateEmitter.emit({
    token: accessToken,
    idToken,
    refreshToken,
    timeSkew
  });
}

// Refresh token manually
export async function refreshToken() {
  try {
    const refreshed = await kc.updateToken(10); // Force token refresh
    return refreshed;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    throw error;
  }
}

// Subscribe to token updates
export function onTokenUpdate(callback) {
  return tokenUpdateEmitter.addListener(callback);
}

// Initialize token refresh listeners
export function initTokenRefreshHandlers() {
  // Handle Keycloak's own token refresh
  kc.onTokenExpired = () => {
    console.log('Token expired, refreshing...');
    kc.updateToken(10)
      .then(refreshed => {
        if (refreshed) {
          console.log('Token refreshed automatically by Keycloak');
          // Emit event to notify other components that token was refreshed
          tokenUpdateEmitter.emit({
            token: kc.token,
            idToken: kc.idToken,
            refreshToken: kc.refreshToken,
            timeSkew: kc.timeSkew
          });
        }
      })
      .catch(error => {
        console.error('Failed to refresh token:', error);
        // You might want to logout or redirect to login page on failure
      });
  };
}

export default {
  getToken,
  getRefreshToken,
  getIdToken,
  updateTokens,
  refreshToken,
  onTokenUpdate,
  initTokenRefreshHandlers
};
